<template>
    <section :class="classes">
        <fieldset :class="mdsNS('form__radio-button-group')" role="group">
            <legend
                v-if="!!title"
                :class="mdsNS('form__radio-button-group-label')"
            >
                {{ title }}
            </legend>
            <markets-ui-radio-button
                v-for="item in radioButtonData"
                :skin="skin"
                :namespaced="namespaced"
                :key="item.id"
                :label="item.name"
                :checked="item.selected"
                :value="item.id"
                :disabled="item.disabled"
                :size="size"
                @change="handleClickItem"
            >
            </markets-ui-radio-button>
        </fieldset>
    </section>
</template>
<script>
import utils from '../../utils';
import mixins from '../mixins';
export default {
    name: 'markets-ui-radio-button-group',
    mixins: [mixins],
    props: {
        title: String,
        dataModel: {
            type: Array,
            default() {
                return [];
            }
        },
        size: {
            type: String,
            validator: function(value) {
                return utils.inArray(['small', 'large'], value) > -1;
            }
        },
        isHorizontal: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            radioButtonData: this.generateRadioButtonData(this.dataModel)
        };
    },
    computed: {
        classes() {
            const cls = [this.namespace()];
            if (this.size) {
                cls.push(this.namespace(`-${this.size}`));
            }
            if (this.isHorizontal) {
                cls.push(
                    this.mdsNS(
                        'form__field-group form__field-group--horizontal'
                    ),
                    this.namespace('__horizontal')
                );
            } else {
                cls.push(this.mdsNS('form__field-group'));
            }
            cls.push(this.skinStyle);
            return cls;
        }
    },
    watch: {
        dataModel: {
            handler(value) {
                this.radioButtonData = this.generateRadioButtonData(value);
            },
            deep: true
        }
    },
    created() {
        this.namespace = utils.namespace('ui-radio-button-group', false);
    },
    methods: {
        generateRadioButtonData(value) {
            return value.map(item => {
                return {
                    id: item.id,
                    name: item.name,
                    selected: item.selected,
                    disabled: item.disabled || false
                };
            });
        },
        handleClickItem(item) {
            this.radioButtonData.forEach(r => {
                r.selected = r.id === item.value;
            });
            this.$emit(
                'change',
                utils.find(this.radioButtonData, r => r.selected)
            );
        }
    }
};
</script>

<style lang="scss">
@import '../../mds/constants';
$namespace: 'markets-ui-radio-button-group';
.#{$namespace} {
    legend {
        padding-bottom: $mds-space-inset-1-and-a-half-x;
    }
    &__horizontal {
        .markets-ui-radio-button-visible-wrap {
            margin: $mds-space-inline-left-1-x;
        }
    }
    &--small {
        legend {
            font-size: $mds-font-size-s;
        }
    }
}
</style>
